// removed by extract-text-webpack-plugin
module.exports = {"ScreenXXSMin":"(min-width: 544px)","ScreenXXSMax":"(max-width: 543px)","hiddenOnMobile":"Ge27337","visibleOnlyOnMobile":"G12bd1b"};